import {
  Chip,
  useTheme,
  alpha
} from "@mui/material";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../core/hooks/useStore";
import { RootState } from "../../../core/store/store";
import { KeywordPigUnlimitedDialog } from "./keyword-pig-unlimited-dialog";
import toolsSlice from "./keyword-pig.slice";

const KeywordPigHeaderCredits = (props: any) => {
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const { apiUrl } = useSelector((state: RootState) => state.home);
  const authState = useSelector((state: RootState) => state.auth);
  const toolsState = useSelector((state: RootState) => state.keywordPig);
  const unlimited = authState.tools?.keywordTool === "unlimited";
  const creditsAvail = !unlimited ? authState.tools?.keywordTool : 0;

  const handleOpen = () => {
    dispatch(toolsSlice.actions.setUnlimitedDialogOpened(true));
  };

  const handleClose = () => {
    dispatch(toolsSlice.actions.setUnlimitedDialogOpened(false));
  };

  return (
    <>
      <Chip
        label={unlimited ? "Unlimited Credits" : `${creditsAvail} Credits`}
        size="small"
        onClick={!unlimited ? handleOpen : undefined}
        sx={{
          ml: 2,
          fontWeight: 600,
          bgcolor: unlimited 
            ? alpha(theme.palette.success.main, 0.1)
            : alpha(theme.palette.warning.main, 0.1),
          color: unlimited 
            ? theme.palette.success.main
            : theme.palette.warning.main,
          border: `1px solid ${unlimited 
            ? alpha(theme.palette.success.main, 0.3)
            : alpha(theme.palette.warning.main, 0.3)}`,
          cursor: !unlimited ? 'pointer' : 'default',
          '&:hover': !unlimited ? {
            bgcolor: unlimited 
              ? alpha(theme.palette.success.main, 0.15)
              : alpha(theme.palette.warning.main, 0.15),
          } : {}
        }}
      />
      <KeywordPigUnlimitedDialog
        open={toolsState.tool.unlimitedDialogOpened}
        onClose={handleClose}
      />
    </>
  );
};

export default KeywordPigHeaderCredits;
